import { SWITCH_PRODUCT_TYPE } from "../lib/types";

// Tutorial actions
export const switchProductType = (change) => dispatch => {
  /* set project type in cache */
  localStorage.setItem("productType", change);
  /* dispatch action */
  dispatch({
    type: SWITCH_PRODUCT_TYPE,
    payload: change
  });
};



// WEBPACK FOOTER //
// ./src/actions/product-type.actions.js